module.exports = __webpack_public_path__ + "media/images/cross-f36663c8ecca41101ff3f95b50e28a86.svg";